import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'wouter';
import { useRouter } from '@medifind/router';
import { BreadcrumbJsonLd } from '@medifind/seo';
import { Button } from './inputs/Button';
import styles from './BreadCrumb.module.scss';

const BreadCrumb = ({ links, className }) => {
  const router = useRouter();
  return (
    <nav aria-label="breadcrumb" className={classNames(styles['breadcrumb-nav'], className)}>
      <BreadcrumbJsonLd
        itemListElements={links.map((link, i) => ({
          position: i + 1,
          name: link.display,
          href: link.href,
        }))}
      />
      <ol className={styles['breadcrumb']}>
        {links.map(({ display, href, urlOptions, className, noSeo }, i) => (
          <li
            key={i}
            className={classNames(styles['breadcrumb-item'], { [styles['active']]: i === links.length - 1 }, className)}
            {...(i === links.length - 1 ? { 'aria-current': 'page' } : {})}
          >
            {i === links.length - 1 ? (
              <span>{display}</span>
            ) : noSeo ? (
              <Button label={display} onClick={() => router.history.push(href)} type="none" />
            ) : (
              <Link to={href} {...(urlOptions || {})}>
                {display}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
BreadCrumb.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      className: PropTypes.string,
      display: PropTypes.string.isRequired,
      noSeo: PropTypes.bool,
      urlOptions: PropTypes.object, // Used for links to determine if it should scroll to the top
    }),
  ).isRequired,
  className: PropTypes.string,
};
export { BreadCrumb as default, BreadCrumb };
